<template>
  <v-date-picker
    :locale="locale"
    :masks="masks"
    :model-config="modelConfig"
    :value="value"
    :min-date="minDate"
    :max-date="maxDate"
    @input="emitInput"
  >
    <template #default="{ inputValue, togglePopover }">
      <v-input
        :value="inputValue"
        class="o-form__input"
        :placeholder="placeholder"
        readonly
        @focus="togglePopover"
      ></v-input>
      <i
        class="o-icon o-icon--time o-typography--action o-form__input-icon"
        @click="togglePopover"
      ></i>
    </template>
  </v-date-picker>
</template>
<script>
  import VInput from '@/index/shared/components/input/index.vue';
  import { dateFormatString } from '@/index/shared/filters';

  const MIN_YEAR = '1900';

  export default {
    components: {
      VInput,
    },
    props: {
      placeholder: String,
      value: String,
      minDate: {
        type: Number,
        default: () => new Date(MIN_YEAR).valueOf(),
      },
      maxDate: Number,
      masks: {
        type: Object,
        default: () => ({
          input: dateFormatString().long,
        }),
      },
      modelConfig: {
        type: Object,
        default: () => ({
          type: 'string',
          mask: 'iso',
        }),
      },
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    computed: {
      locale() {
        return this.subscriber.currentLanguage;
      },
    },
    methods: {
      emitInput(value) {
        this.$emit('input', value);
      },
    },
  };
</script>
